import React from 'react'
import { Flex, FlexProps } from 'rebass/styled-components'

import { BreadcrumbItem } from './BreadcrumbItem'
import { BreadcrumbIcon, type IconItem } from './BreadcrumbIcon'
import { BreadcrumbLink, type LinkItem } from './BreadcrumbLink'
import { BreadcrumbTitle, type TitleItem } from './BreadcrumbTitle'

interface DropdownItem {
  type: 'dropdown'
  component: React.ReactNode
}

export type BreadcrumbItem = IconItem | LinkItem | TitleItem | DropdownItem

export interface BreadcrumbsProps extends FlexProps {
  items: BreadcrumbItem[]
}

export const Breadcrumbs = ({ items, sx, ...props }: BreadcrumbsProps): JSX.Element => (
  <Flex
    data-name="Breadcrumbs"
    as="ul"
    sx={{ flexWrap: 'wrap', alignItems: 'center', gap: '8px', listStyleType: 'none', ...sx }}
    {...props}
  >
    {items.map((item, index) => {
      const isLastItem = index === items.length - 1

      if (item.type === 'icon') {
        return (
          <BreadcrumbItem key={index} isLastItem={isLastItem}>
            <BreadcrumbIcon {...item} />
          </BreadcrumbItem>
        )
      }

      if (item.type === 'link') {
        return (
          <BreadcrumbItem key={index} isLastItem={isLastItem}>
            <BreadcrumbLink {...item} />
          </BreadcrumbItem>
        )
      }

      if (item.type === 'title') {
        return (
          <BreadcrumbItem key={index} isLastItem={isLastItem}>
            <BreadcrumbTitle key={index} {...item} />
          </BreadcrumbItem>
        )
      }

      if (item.type === 'dropdown') {
        return (
          <BreadcrumbItem key={index} isLastItem={isLastItem} sx={{ gap: '15px', mr: '7px' }}>
            <React.Fragment key={index}>{item.component}</React.Fragment>
          </BreadcrumbItem>
        )
      }
    })}
  </Flex>
)
